import { render, staticRenderFns } from "./photoAlbum.vue?vue&type=template&id=47c6894c&scoped=true&"
import script from "./photoAlbum.vue?vue&type=script&lang=js&"
export * from "./photoAlbum.vue?vue&type=script&lang=js&"
import style0 from "./photoAlbum.vue?vue&type=style&index=0&id=47c6894c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47c6894c",
  null
  
)

export default component.exports